let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("igWxE")).then(() => parcelRequire('1znBb'));